export default "__VITE_ASSET__ff52aaaf__"